import { useTranslation } from "react-i18next";
import { Link } from "react-router";
import { Button } from "~/atoms/button";

export default function NotFound() {
  const { t } = useTranslation();
  return (
    <div className="flex min-h-[50vh] flex-col items-center justify-center space-y-6">
      <h1 className="text-center text-3xl font-bold">
        {t("commons.pageNotFound")}
      </h1>
      <Button variant="link" asChild className="text-lg">
        <Link to="/">{t("commons.buttons.goToTheDashboardPage")}</Link>
      </Button>
    </div>
  );
}
